import AddAccountScreen from "../../setting/AddAccountScreen";
import React from "react";
import { PersonalDetails } from "../../Mine/PersonalDetails";
import { AccountSecuritySetting } from "../../setting/account_security_setting";
import { OtherSetting } from "../../setting/other_setting";
import { PrivacySetting } from "../../setting/privacy_setting";
import { ChatList } from "../../Chat/ChatList";
import { ChatDetail } from "../../Chat/ChatDetail";
import { Report } from "../../Chat/Report";
import { MainTabScreen } from "../../MainTabScreen";
import { SearchFriend } from "../../Chat/SearchFriend";
import { AskAccountDel } from "../../setting/AskAccountDel";
import { SendChatTimeSetting } from "../../setting/SendChatTimeSetting";
import { UpdatePsdSetting } from "../../setting/UpdatePsdSetting";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { ContactInfo, ContactInfoModeal } from "../../Contact/ContactInfo";
import { MainParamList } from "./MainParamList";
import { FriendApplyList } from "../../Contact/FriendApplyList";
import { SearchChatResultScreen } from "../../Chat/SearchChatResult";
import { ContactApply } from "../../Contact/ContactApply";
import { ContactSetting } from "../../Contact/ContactSetting";
import { ForwardNewChat } from "../../Chat/ForwardNewChat";
import { GroupList } from "../../Contact/GroupList";
import { BlackList } from "../../Contact/BlackList";
import { Announcement } from "../../Announcement";
import { CommonWeb } from "../../CommonWeb";
import { QRCodeScreen } from "../../QRCodeScreen";
import BarCodeScanner from "../../BarCodeScanner";
import { HtmlTextScreen } from "../../HtmlTextScreen";
import { VideoScreen } from "../../VideoScreen";
import { ImageScreen } from "../../ImageScreen";
import { MediaPreviewScreen } from "../../MediaPreviewScreen";
import { OpenSecurity } from "../../setting/OpenSecurity";
import { BindPhoneOrEmail } from "../../setting/BindPhoneOrEmail";
import { ForwardChat } from "../../Chat/ForwardChat";
import { ChatTalk } from "../../Chat/ChatTalk";
import { Feedback } from "../../feedback";
import { ChatSearch } from "../../Chat/ChatSearch";
import { MoreChatContactSearch } from "../../Chat/MoreChatContactSearch";
import { MoreChatMsgSearch } from "../../Chat/MoreChatMsgSearch";
import { MoreChatGroupSearch } from "../../Chat/MoreChatGroupSearch";
import { ScannerApplyScreen } from "../../ScannerApplyScreen";
import { ContactsLabel } from "../../Contact/ContactsLabel";
import { QuickSearchMsgScreen } from "../../Chat/QuickSearchMsgScreen";
import { SearchDatePickScreen } from "../../Chat/SearchDatePickScreen";
import { CollectImageManagerScreen } from "../../Chat/CollectImageManagerScreen";
import { SwitchAccount } from "../../setting/SwitchAccount";
import { MassSendingAssistant } from "../../Chat/MassSendingAssistant";
import { AnnouncementDetail } from "../../AnnouncementDetail";
import { MineRemark } from "../../Mine/MineRemark";
import { GroupManager } from "../../Chat/group/GroupManager";
import { GroupUserScreen } from "../../Chat/group/GroupUserScreen";
import { GroupNotice } from "../../Chat/group/GroupNotice";
import { GroupChatFontSetting } from "../../Chat/group/GroupChatFontSetting";
import { JoinGroupScreen } from "../../Chat/group/JoinGroupScreen";
import { GroupRemoveOrAddUser } from "../../Chat/group/GroupRemoveOrAddUser";
import { SettingIntervalTime } from "../../Chat/group/SettingIntervalTime";
import { GroupBlackAddOrRemove } from "../../Chat/group/GroupBlackAddOrRemove";
import { GroupHandleAdmin } from "../../Chat/group/GroupHandleAdmin";
import { GroupTransferUser } from "../../Chat/group/GroupTransferUser";
import { MainCountryCodeSelete } from "../../CountryCodeSelete";
import { PcLoginConfirmScreen } from "../../PcLoginConfirmScreen";
import { UpgradeGuideScreen } from "../../login/UpgradeGuideScreen";
import { QRCodeScreenModal } from "../../QRCodeModal";
import { ContactsLabelScreen } from "../../label/ContactsLabelScreen";
import { LabelDetailScreen } from "../../label/LabelDetailScreen";
import { UpdateLabelModal } from "../../label/UpdateLabelModal";
import { AddUserModal } from "../../label/AddUserModal";
import { RemoveUserModal } from "../../label/RemoveUserModal";
const Stack = createNativeStackNavigator<MainParamList>();

const MainStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false, animation: "ios" }}>
      <Stack.Screen name={"MainTab"} component={MainTabScreen} />
      <Stack.Screen name={"PersonalDetails"} component={PersonalDetails} />
      <Stack.Screen
        name={"MineRemark"}
        component={MineRemark}
        options={options()}
      />
      <Stack.Screen
        name={"AccountSecuritySetting"}
        component={AccountSecuritySetting}
      />
      <Stack.Screen name={"OtherSetting"} component={OtherSetting} />
      <Stack.Screen name={"PrivacySetting"} component={PrivacySetting} />
      <Stack.Screen name={"ChatList"} component={ChatList} />
      <Stack.Screen name={"ForwardChat"} component={ForwardChat} />
      <Stack.Screen
        name={"ChatDetail"}
        component={ChatDetail}
        options={{
          animation: "slide_from_right",
          presentation: "card",
        }}
      />
      <Stack.Screen name={"Report"} component={Report} options={options()} />
      <Stack.Screen
        name={"SearchFriend"}
        component={SearchFriend}
        options={options()}
      />
      <Stack.Screen
        name={"AskAccountDel"}
        component={AskAccountDel}
        options={options()}
      />
      <Stack.Screen
        name={"SendChatTimeSetting"}
        component={SendChatTimeSetting}
      />
      <Stack.Screen
        name={"UpdatePsdSetting"}
        component={UpdatePsdSetting}
        options={options()}
      />
      <Stack.Screen name={"ContactInfo"} component={ContactInfo} />
      <Stack.Screen
        name={"ContactInfoModeal"}
        component={ContactInfoModeal}
        options={options()}
      />
      <Stack.Screen name={"FriendApplyList"} component={FriendApplyList} />
      <Stack.Screen
        name={"GroupUserList"}
        component={GroupUserScreen}
        options={options()}
      />
      <Stack.Screen name={"ContactApply"} component={ContactApply} options={options()} />
      <Stack.Screen
        name={"ContactSetting"}
        component={ContactSetting}
        options={options()}
      />
      <Stack.Screen
        name={"ForwardNewChat"}
        component={ForwardNewChat}
        options={options()}
      />
      <Stack.Screen name={"GroupList"} component={GroupList} />
      <Stack.Screen
        name={"BlackList"}
        component={BlackList}
        options={options()}
      />
      <Stack.Screen name={"Announcement"} component={Announcement} />
      <Stack.Screen
        name={"AnnouncementDetail"}
        component={AnnouncementDetail}
        options={options()}
      />
      <Stack.Screen name={"CommonWeb"} component={CommonWeb} />
      <Stack.Screen name={"HtmlTextScreen"} component={HtmlTextScreen} />
      <Stack.Screen
        name={"QRCodeScreen"}
        component={QRCodeScreenModal}
        options={options()}
      />
      <Stack.Screen
        name={"GroupManager"}
        component={GroupManager}
        options={options()}
      />
      <Stack.Screen name={"BarCodeScanner"} component={BarCodeScanner} />
      <Stack.Screen
        name={"VideoScreen"}
        component={VideoScreen}
        options={{ animation: "none" }}
      />
      <Stack.Screen
        name={"ImageScreen"}
        component={ImageScreen}
        options={{ animation: "none" }}
      />
      <Stack.Screen
        name={"MediaPreviewScreen"}
        component={MediaPreviewScreen}
        options={{ animation: "none" }}
      />
      <Stack.Screen
        name={"SearchChatResultScreen"}
        options={options()}
        component={SearchChatResultScreen}
      />
      <Stack.Screen
        name={"OpenSecurity"}
        component={OpenSecurity}
        options={options()}
      />
      <Stack.Screen
        name={"BindPhoneOrEmail"}
        component={BindPhoneOrEmail}
        options={options()}
      />
      <Stack.Screen
        name={"ChatTalk"}
        options={options()}
        component={ChatTalk} />
      <Stack.Screen
        name={"Feedback"}
        component={Feedback}
        options={options()}
      />
      <Stack.Screen
        name={"ChatSearch"}
        component={ChatSearch}
        options={options()} />
      <Stack.Screen
        name={"MoreChatContactSearch"}
        options={options()}
        component={MoreChatContactSearch}
      />
      <Stack.Screen
        name={"MoreChatMsgSearch"}
        component={MoreChatMsgSearch}
        options={options()}
      />
      <Stack.Screen
        name={"MoreChatGroupSearch"}
        options={options()}
        component={MoreChatGroupSearch}
      />
      <Stack.Screen
        name={"GroupNotice"}
        component={GroupNotice}
        options={options()}
      />
      <Stack.Screen
        name={"ScannerApplyScreen"}
        component={ScannerApplyScreen}
      />
      <Stack.Screen
        name={"ContactsLabelScreen"}
        component={ContactsLabelScreen}
        options={options()}
      />
      <Stack.Screen
        name={"LabelDetailScreen"}
        component={LabelDetailScreen}
        options={options()}
      />
      <Stack.Screen
        name={"UpdateLabelModal"}
        component={UpdateLabelModal}
        options={options()}
      />
      <Stack.Screen
        name={"AddUserModal"}
        component={AddUserModal}
        options={options()}
      />
       <Stack.Screen
        name={"RemoveUserModal"}
        component={RemoveUserModal}
        options={options()}
      />


      <Stack.Screen
        name={"ContactsLabel"}
        component={ContactsLabel}
        options={options()}
      />
      <Stack.Screen
        name={"QuickSearchMsgScreen"}
        options={options()}
        component={QuickSearchMsgScreen}
      />
      <Stack.Screen
        name={"SearchDatePickScreen"}
        options={options()}
        component={SearchDatePickScreen}
      />
      <Stack.Screen
        name={"CollectImageManagerScreen"}
        component={CollectImageManagerScreen}
      />
      <Stack.Screen
        name={"SwitchAccount"}
        component={SwitchAccount}
        options={options()}
      />
      <Stack.Screen
        name={"AddAccount"}
        component={AddAccountScreen}
        options={options()}
      />
      <Stack.Screen
        name={"MassSendingAssistant"}
        component={MassSendingAssistant}
      />
      <Stack.Screen
        name={"GroupChatFontSetting"}
        component={GroupChatFontSetting}
        options={options()}
      />
      <Stack.Screen
        name={"JoinGroupScreen"}
        options={options()}
        component={JoinGroupScreen} />
      <Stack.Screen
        name={"GroupRemoveOrAddUser"}
        options={options()}
        component={GroupRemoveOrAddUser}
      />
      <Stack.Screen
        name={"SettingIntervalTime"}
        component={SettingIntervalTime}
        options={options()}
      />
      <Stack.Screen
        name={"GroupBlackAddOrRemove"}
        component={GroupBlackAddOrRemove}
        options={options()}
      />
      <Stack.Screen
        name={"GroupHandleAdmin"}
        component={GroupHandleAdmin}
        options={options()}
      />
      <Stack.Screen
        name={"GroupTransferUser"}
        component={GroupTransferUser}
        options={options()}
      />
      <Stack.Screen
        name={"MainCountryCodeSelete"}
        component={MainCountryCodeSelete}
      />
      <Stack.Screen
        name={"PcLoginConfirmScreen"}
        component={PcLoginConfirmScreen}
      />
      <Stack.Screen
        name={"UpgradeGuideScreen"}
        component={UpgradeGuideScreen}
        options={{
          headerShown: false,
          presentation: "transparentModal", // 或 'modal'
          animation: "fade", // 或 'fade'
        }}
      />

    </Stack.Navigator>
  );
};
export default MainStack;
function options(): any {
  return {
    headerShown: false,
    presentation: "transparentModal",
    animation: "fade",
    contentStyle: {
      backgroundColor: "transparent",
      padding: 0,
    },
  };
}
